module.exports = __webpack_public_path__ + "static/media/ms.25f790bf.svg";